<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6 flexben-page-title">
        <h1>{{ $t("flexben.provider.title") }}</h1>
      </div>
    </div>
    <div class="container-bg-white mt-3">
      <div class="row p-3">
        <div class="col-12">
          <table :id="table.id" class="display table table-hover dataTable swal-datatable"
                 :data-columns='JSON.stringify(table.header)'>
          </table>
        </div>
      </div>

    </div>
    <content-loader :loader-visible="this.loading" :loader-error="loaderError"></content-loader>
  </div>
</template>
<script>
import DataTable from "datatables.net-dt";
import i18n from "@/plugins/language/i18n";
import HttpTreeService from "@/superUp-module/resources/services/httpTreeService";
import ApiHelper from "@/multiben-module/src/services/helper/apiHelper";
import httpFlexben from "@/http/http-flexben";

export default {
  name: 'FlexBenProviders',
  data() {
    return {
      loading: false,
      loaderError: false,
      refreshTable: false,
      datatable: null,
      table: {
        id: 'providerTableID',
        ajax: `${ApiHelper.getBaseUrl('v1')}${httpFlexben.provider.providerPathPrefix}/list`,
        header: [
          {title: i18n.t('flexben.provider.table.header.name'), name: 'name', data: 'name', orderable: false},
          {
            title: i18n.t('flexben.provider.table.header.discount_module'),
            name: 'discount_module',
            data: 'discount_module',
            orderable: false
          },
        ]
      },
    }
  },
  methods: {
    initTable() {
      this.loading = true
      const instance = this;

      this.datatable = new DataTable(`#${this.table.id}`, {
        serverSide: true,
        autoWidth: false,
        searching: true,
        responsive: true,
        search: {
          return: true
        },
        lengthMenu: [15, 25, 50],
        ajax: {
          beforeSend: function (request) {
            request.setRequestHeader("X-Up-Language", i18n.locale);
            request.setRequestHeader("Authorization", `Barier ${HttpTreeService.getToken()}`);
            request.setRequestHeader("Content-Type", "application/json;charset=utf-8");
          },
          url: this.table.ajax,
          data: (data) => {
            return {
              ...data
            };
          }
        },
        pagingType: "full_numbers",
        //stateSave: stateSave,
        processing: false,
        drawCallback: () => {
          this.loading = false;
        },
        createdRow: function (row, data) {
          const discountModule = row.querySelector('input[data-name="discount_module"]');

          if (discountModule && !discountModule.dataset.listenerBound) {
            discountModule.dataset.listenerBound = '1';

            discountModule.addEventListener('click', async () => {
              instance.processDiscountModuleConfig(discountModule);
            });
          }
        },
        columns: instance.table.header
      });
    },

    processDiscountModuleConfig(input) {
      const id = input.getAttribute('data-id');

      const doRequest = (action) => {
        this.loading = true;
        httpFlexben.provider.config.discountModule({
          id: id,
          action: action
        }).then(res => {
          this.loading = false;
        }).catch(err => {
          this.loading = false;
          this.loaderError = true;
        })
      }

      if (input.checked && id) {
        doRequest(true);
        return;
      }

      if (id) {
        doRequest(false);
      }
    }
  },
  mounted() {
    if (!document.getElementById('font-awesome-cdn')) {
      const link = document.createElement('link');
      link.id = 'font-awesome-cdn'; // Assign an ID to check existence
      link.rel = 'stylesheet';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css';
      document.head.appendChild(link);
    }
    this.initTable()
  },

  watch: {
    refreshTable: function (val) {
      if (val) {
        this.loading = true;
        this.datatable.destroy();
        this.datatable = null;
        this.initTable();
      }
    },
  }
}
</script>
